import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import de from './DE';
import en from './EN';
import es from './ES';
import fr from './FR';
import he from './HE';
import it from './IT';
import ja from './JA';
import ko from './KO';
import nl from './NL';
import ptBr from './PT-BR';
import ru from './RU';

const resources = {
	de: {translation: de},
	en: {translation: en},
	es: {translation: es},
	fr: {translation: fr},
	he: {translation: he},
	it: {translation: it},
	ja: {translation: ja},
	ko: {translation: ko},
	nl: {translation: nl},
	ptBr: {translation: ptBr},
	ru: {translation: ru},
};

i18n
	.use(initReactI18next) // bind react-i18next to the instance
	.init({
		resources,
		fallbackLng: 'en',
		lng: localStorage.getItem('favoriteLanguage') || navigator.language.split('-')[0],
		debug: true,

		interpolation: {
			escapeValue: false, // not needed for react!!
		},

		// react i18next special options (optional)
		// override if needed - omit if ok with defaults
		/*
		react: {
		  bindI18n: 'languageChanged',
		  bindI18nStore: '',
		  transEmptyNodeValue: '',
		  transSupportBasicHtmlNodes: true,
		  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
		  useSuspense: true,
		}
		*/
	});

export default i18n